import { articlesFor } from './pageHelp';
import { findArticle } from './articles';

/** Where the Help button goes for this address: its article, its articles, or its area's help list. */
export function pageHelpTarget(pathname: string, search = ''): { kind: 'article' | 'menu' | 'list'; to: string; slugs: string[] } {
  const from = encodeURIComponent(pathname + search);
  const { entry, articles } = articlesFor(pathname, search);
  const slugs = articles.filter((s) => !!findArticle(s));
  if (slugs.length === 1) return { kind: 'article', to: `/help/${slugs[0]}?from=${from}`, slugs };
  const area = entry ? `area=${entry.area}&` : '';
  const list = pathname === '/help' ? '/help' : `/help?${area}from=${from}`;
  return { kind: slugs.length > 1 ? 'menu' : 'list', to: list, slugs };
}
